import SimpleReactValidator from 'shared/utils/simple-react-validator';
import { toast } from 'react-hot-toast';
import { PRICE_SELECTED } from 'shared/data/quoteSteps';
import { selectAssemblyDataForValidate } from 'us_pcb_assembly/store/selectors';
import { updateValidatorFlag } from 'us_pcb_assembly/store/slice';

export const validator = new SimpleReactValidator({});

export const projectValidator = new SimpleReactValidator({});

export const validate = () => (dispatch, getState) => {
  const { quoteStep, parametersChanged } = selectAssemblyDataForValidate(getState());

  let validateResult = true;

  if (quoteStep === PRICE_SELECTED) {
    if (!validator.allValid()) {
      validator.showMessages();
      dispatch(updateValidatorFlag());
      toast.error('Please fix the errors in the form');
      validateResult = false;
    }

    if (!projectValidator.allValid()) {
      projectValidator.showMessages();
      dispatch(updateValidatorFlag());
      toast.error('Please fix the errors in the form');
      validateResult = false;
    }
  }

  if (parametersChanged) {
    validateResult = false;
  }

  return validateResult;
};
